/**
 * AssistantProfile.jsx
 * src/pages/assistant/AssistantProfile.jsx
 */

import { useState, useEffect } from "react";
import { Avatar, apiFetch } from "../../components/helpers";


function FeedbackMsg({ text, ok = true }) {
  if (!text) return null;
  return <div className={`alert alert-${ok ? "success" : "danger"} py-2 px-3 mb-3`} style={{ fontSize: 12 }}>{text}</div>;
}

function SectionCard({ title, subtitle, children }) {
  return (
    <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: 16 }}>
      <div className="card-header border-0 px-4 py-3" style={{ background: "#FAFBFC", borderRadius: "16px 16px 0 0" }}>
        <h6 className="fw-bold mb-1" style={{ color: "#0A1628", fontSize: 14 }}>{title}</h6>
        {subtitle && <p className="text-muted mb-0" style={{ fontSize: 12 }}>{subtitle}</p>}
      </div>
      <div className="card-body px-4 py-4">{children}</div>
    </div>
  );
}

export default function AssistantProfile() {
  const authUser = (() => { try { return JSON.parse(localStorage.getItem("adminuser") || "{}"); } catch { return { name: "Assistant", email: "" }; } })();
  const assistantId = authUser.assistant_id || localStorage.getItem("assistant_id");

  const [profile,     setProfile]     = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [profileForm, setProfileForm] = useState({ name: "", phone: "", specialization: "", experience: "", qualifications: "" });
  const [pwForm,      setPwForm]      = useState({ current_password: "", new_password: "", confirm_password: "" });
  const [profileMsg,  setProfileMsg]  = useState({ text: "", ok: true });
  const [pwMsg,       setPwMsg]       = useState({ text: "", ok: true });
  const [saving,      setSaving]      = useState(false);
  const [pwSaving,    setPwSaving]    = useState(false);

  const load = async () => {
    console.log(localStorage.getItem("assId"))
    if (!assistantId) return;
    setLoading(true);
    try {
      const json = await apiFetch(`${process.env.REACT_APP_GET_ASSISTANT_PROFILE}`, {
        method: "POST",
        body: { assistant_id: assistantId }
      });
      console.log(json.status)
      if (json.status && json.data) {
        
        setProfile(json.data);
        setProfileForm({ 
          name: json.data.name || "", 
          phone: json.data.phone || "", 
          specialization: json.data.specialization || "", 
          experience: json.data.experience || "", 
          qualifications: json.data.qualifications || "" 
        });
      }
    } catch (err) {
      console.error("Profile load error:", err);
    }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const saveProfile = async () => {
    let assistant_id=localStorage.getItem("assId");
    const assistantId = assistant_id;

    if (!profileForm.name.trim())           return setProfileMsg({ text: "Name is required", ok: false });
    if (!profileForm.phone.trim())          return setProfileMsg({ text: "Phone is required", ok: false });
    if (!profileForm.specialization.trim()) return setProfileMsg({ text: "Specialization is required", ok: false });
    setSaving(true); setProfileMsg({ text: "", ok: true });
    try {
      const json = await apiFetch(`${process.env.REACT_APP_UPDATE_ASSISTANT}`, {
        method: "POST",
        body: { assistant_id: assistantId, ...profileForm }
      });
      setProfileMsg({ text: json.status ? "Profile updated!" : json.message || "Failed", ok: !!json.status });
      if (json.status) {
        // Update localStorage so other components reflect the change
        const updatedUser = { ...authUser, name: profileForm.name };
        localStorage.setItem("adminuser", JSON.stringify(updatedUser));
        load();
      }
    } catch { setProfileMsg({ text: "Network error", ok: false }); }
    setSaving(false);
    setTimeout(() => setProfileMsg({ text: "", ok: true }), 4000);
  };

  const savePassword = async () => {

    let admin_id=localStorage.getItem("adminId")
    if (!pwForm.current_password)            return setPwMsg({ text: "Current password is required", ok: false });
    if (pwForm.new_password.length < 6)      return setPwMsg({ text: "New password must be at least 6 characters", ok: false });
    if (pwForm.new_password !== pwForm.confirm_password) return setPwMsg({ text: "Passwords do not match", ok: false });
    setPwSaving(true); setPwMsg({ text: "", ok: true });
    try {
      const endpoint = process.env.REACT_APP_UPDATE_ADMIN_PASSWORD || "update_admin_password.php";
      const json = await apiFetch(endpoint, {
        method: "POST",
        body: { 
          admin_id: admin_id, 
          current_password: pwForm.current_password, 
          new_password: pwForm.new_password 
        }
      });
      setPwMsg({ text: json.status ? "Password updated!" : json.message || "Failed", ok: !!json.status });
      if (json.status) setPwForm({ current_password: "", new_password: "", confirm_password: "" });
    } catch { setPwMsg({ text: "Network error", ok: false }); }
    setPwSaving(false);
    setTimeout(() => setPwMsg({ text: "", ok: true }), 4000);
  };

  const inp = "form-control";

  return (
    <div className="p-3 p-lg-4" style={{ minHeight: "100vh", fontFamily: "'Nunito','Segoe UI',sans-serif"}}>
      <div className="mb-4">
        <h4 className="fw-bold mb-1" style={{ color: "#0A1628" }}>My Profile</h4>
        <p className="text-muted mb-0" style={{ fontSize: 13 }}>Manage your personal information and account settings</p>
      </div>

      {/* Profile header card */}
      <div className="card border-0 shadow-sm mb-4 p-4" style={{ borderRadius: 16 }}>
        <div className="d-flex align-items-center gap-4 flex-wrap">
          <Avatar name={profile?.name || authUser.name} size={72} />
          <div>
            <h5 className="fw-bold mb-1" style={{ color: "#0A1628" }}>{profile?.name || authUser.name}</h5>
            <p className="text-muted mb-1" style={{ fontSize: 13 }}>{profile?.email || authUser.email}</p>
            {profile && <><p className="mb-0" style={{ fontSize: 13, color: "#D85A30", fontWeight: 600 }}>{profile.specialization}</p>
            <span className="badge mt-1" style={{ background: profile.status === "active" ? "#E1F5EE" : "#FCEBEB", color: profile.status === "active" ? "#085041" : "#501313", fontSize: 11, textTransform: "specialization" }}>{profile.status}</span></>}
          </div>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-5"><div className="spinner-border" style={{ color: "#D85A30" }} /></div>
      ) : (
        <>
          {/* Edit Profile */}
          <SectionCard title="Edit Profile" subtitle="Update your personal and professional details">
            <div className="row g-3">
              <div className="col-md-6"><label className="form-label fw-bold text-muted" style={{ fontSize: 11 }}>FULL NAME *</label><input className={inp} value={profileForm.name} onChange={e => setProfileForm({ ...profileForm, name: e.target.value })} /></div>
              <div className="col-md-6"><label className="form-label fw-bold text-muted" style={{ fontSize: 11 }}>PHONE *</label><input className={inp} value={profileForm.phone} onChange={e => setProfileForm({ ...profileForm, phone: e.target.value })} placeholder="+91 98765 43210" /></div>
              <div className="col-md-6"><label className="form-label fw-bold text-muted" style={{ fontSize: 11 }}>SPECIALIZATION *</label><input className={inp} value={profileForm.specialization} onChange={e => setProfileForm({ ...profileForm, specialization: e.target.value })} /></div>
              <div className="col-md-6"><label className="form-label fw-bold text-muted" style={{ fontSize: 11 }}>EXPERIENCE</label><input className={inp} value={profileForm.experience} onChange={e => setProfileForm({ ...profileForm, experience: e.target.value })} placeholder="e.g. 3 years" /></div>
              <div className="col-12"><label className="form-label fw-bold text-muted" style={{ fontSize: 11 }}>QUALIFICATIONS</label><input className={inp} value={profileForm.qualifications} onChange={e => setProfileForm({ ...profileForm, qualifications: e.target.value })} placeholder="e.g. BDH, Diploma in Dental Assisting" /></div>
            </div>
            <div className="mt-3">
              <FeedbackMsg text={profileMsg.text} ok={profileMsg.ok} />
              <button className="btn fw-bold text-white" style={{ background: "#D85A30" }} onClick={saveProfile} disabled={saving}>
                {saving ? <><span className="spinner-border spinner-border-sm me-1" />Saving...</> : "Save Changes"}
              </button>
            </div>
          </SectionCard>

          {/* Change Password */}
          <SectionCard title="Change Password" subtitle="Update your login password (min 6 characters)">
            <div className="row g-3">
              <div className="col-12"><label className="form-label fw-bold text-muted" style={{ fontSize: 11 }}>CURRENT PASSWORD</label><input type="password" className={inp} value={pwForm.current_password} onChange={e => setPwForm({ ...pwForm, current_password: e.target.value })} placeholder="Enter current password" /></div>
              <div className="col-md-6"><label className="form-label fw-bold text-muted" style={{ fontSize: 11 }}>NEW PASSWORD</label><input type="password" className={inp} value={pwForm.new_password} onChange={e => setPwForm({ ...pwForm, new_password: e.target.value })} placeholder="Min 6 characters" /></div>
              <div className="col-md-6"><label className="form-label fw-bold text-muted" style={{ fontSize: 11 }}>CONFIRM NEW PASSWORD</label><input type="password" className={inp} value={pwForm.confirm_password} onChange={e => setPwForm({ ...pwForm, confirm_password: e.target.value })} placeholder="Repeat new password" /></div>
            </div>
            <div className="mt-3">
              <FeedbackMsg text={pwMsg.text} ok={pwMsg.ok} />
              <button className="btn fw-bold text-white" style={{ background: "#D85A30" }} onClick={savePassword} disabled={pwSaving}>
                {pwSaving ? <><span className="spinner-border spinner-border-sm me-1" />Updating...</> : "Update Password"}
              </button>
            </div>
          </SectionCard>
        </>
      )}
    </div>
  );
}